// @modified: add refreshAuth
// @version V0.0.3 [Saturday - 20210109_100956] : add global component
// @version V0.0.2 [Tuesday - 20201103_092526] : added precall vuex for some predata, and loadParentMethodMixin
// @version V0.0.1 [Wednesday - 20201028_093838] : init

require('./bootstrap');
require('./LoadAddon/loadGlobalComponent');
require('./LoadAddon/loadFontAwesome');
require('./LoadAddon/loadOther')

import Vue from 'vue';
import { router } from "./LoadAddon/loadVueRouter";
import { store } from "./LoadAddon/loadVueX";

// router hook, should call before Vue instance
require('./LoadAddon/routerHook')
 
/**
 * precall vuex, need some predata
 */
// get page list
store.dispatch('page/loadPage');
store.dispatch('generalSetting/loadKeyList');
// auth
async() => await store.dispatch('authUser/refreshAuth');
 
import loadParentMethodMixin from '@vue-libraries/Mixin/parentMethodMixin'

const app = new Vue({
    el: '#app',
    router,
    store,
    mixins: [ loadParentMethodMixin ]
}).$mount('#app')

window.app = app;


